export const atomicDir = file => {
  const filePath = file.split('/');
  return filePath.slice(filePath.length - 3, filePath.length - 2)[0];
};

export function onDocumentLoaded (callback) {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', callback)
  } else {
    callback()
  }
}

export function onStateChange (callback) {
  document.onreadystatechange = function () {
    if (document.readyState === 'complete') {
      callback();
    }
  }
}

export function onResize (callback) {
  if (document.readyState !== 'complete') {
    window.addEventListener('resize', callback)
  } else {
    callback()
  }
}